import { gql } from '@apollo/client';
import RESOURCE_FRAGMENT from '../../fragments/resource';

const GET_FAVORITE_RESOURCES = gql`
  query {
    favorites {
      id
      pageId
      page {
        id
        pageNumber
        book {
          id
          title
        }
      }
      resourceId
      resource {
        ...BaseResource
      }
    }
  }
  ${RESOURCE_FRAGMENT}
`;

export default GET_FAVORITE_RESOURCES;
